import { render } from "./FilesRenameBeforeUploadModal.vue?vue&type=template&id=56c31b39&scoped=true&lang=pug"
import script from "./FilesRenameBeforeUploadModal.vue?vue&type=script&lang=js"
export * from "./FilesRenameBeforeUploadModal.vue?vue&type=script&lang=js"

import "./FilesRenameBeforeUploadModal.vue?vue&type=style&index=0&id=56c31b39&lang=sass&scoped=true"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c31b39"]])

export default __exports__